import React, { useState } from "react";
import {
  CDropdown,
  CButton,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { ReactComponent as PlusCircle } from "../../../assets/icons/plus-circle.svg";
import CreateClinic from "../../pages/ops/Modals/CreateClinic";
import CreateHealthCareGroup from "../../pages/ops/Modals/CreateHealthCareGroup";
const OPSPrimaryHeader = ({
  titleText,
  subTitleText = "",
  pillText = "",
  showPill = false,
  showSubtitle = false,
  styles = {},
  classnames = "",
  showButton = true,
}) => {
  const [newClinicModalStatus, setNewClinicModalStatus] = useState(false);
  const [newHealthCareModalStatus, setNewHealthCareModalStatus] =
    useState(false);
  return (
    <div style={{ margin: "0px", padding: "0px" }}>
      <CreateClinic
        modalIsOpen={newClinicModalStatus}
        setIsOpen={setNewClinicModalStatus}
      />
      <CreateHealthCareGroup
        modalIsOpen={newHealthCareModalStatus}
        setIsOpen={setNewHealthCareModalStatus}
      />
      <div
        className="d-flex justify-content-between container-fluid px-1 py-4 w-100"
        style={{ margin: "0px", padding: "0px", ...styles }}
        classnames={`${classnames}`}
      >
        <div
          className="d-flex"
          style={{
            margin: "0px",
            padding: "0px",
            gap: "15px",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <h4
              className="primary-text"
              style={{ textAlign: "start", textTransform: "capitalize" }}
            >
              {titleText}
            </h4>
            {showSubtitle && (
              <span className="secondary-text">{subTitleText}</span>
            )}
          </div>
          {showPill && (
            <div
              style={{
                padding: "5px 8px",
                backgroundColor: "#e5eaf1",
                color: "#344054",
                width: "fit-content",
                height: "fit-content",
                borderRadius: "18px",
              }}
            >
              {pillText}
            </div>
          )}
        </div>
        {showButton ? (
          <CDropdown>
            <CButton
              onClick={() => {
                setNewClinicModalStatus(true);
              }}
              className="dropdown-button-primary"
            >
              <PlusCircle
                fill="white"
                style={{ marginRight: "4px", marginTop: "-2px" }}
              />{" "}
              Create New
            </CButton>
            <CDropdownToggle split className="dropdown-button-primary" />
            <CDropdownMenu>
              <CDropdownItem
                onClick={() => {
                  setNewHealthCareModalStatus(true);
                }}
              >
                New Health Group
              </CDropdownItem>
              <CDropdownItem
                onClick={() => {
                  setNewClinicModalStatus(true);
                }}
              >
                New Clinic
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default OPSPrimaryHeader;
